import { render, staticRenderFns } from "./ConnectorMapperForm.vue?vue&type=template&id=4b486f20&"
import script from "./ConnectorMapperForm.vue?vue&type=script&lang=ts&"
export * from "./ConnectorMapperForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports